export const LEGAL_PATHS = ['/privacy', '/terms', '/data-deletion'] as const;

export type LegalPath = (typeof LEGAL_PATHS)[number];

export function isLegalPath(path: string): path is LegalPath {
    return (LEGAL_PATHS as readonly string[]).includes(path);
}
